import { Link } from 'react-router-dom'
import './menu-selector.component.css'
import { useMemo } from 'react'

const MenuSelectorComponent = (props) => {
  const { restaurant } = props

  const menus = useMemo(() => {
    let arr = []
    if (restaurant.selectedLocation) {
      if (restaurant.selectedLocation.menus?.length > 0) {
        arr = restaurant.selectedLocation.menus
      } else {
        if (restaurant.selectedLocation.pdfMenuLink) {
          arr.push({
            label: 'View Menu',
            menu: { url: restaurant.selectedLocation.pdfMenuLink },
          })
        }

        if (restaurant.selectedLocation.pdfCateringMenuLink) {
          arr.push({
            label: 'View Catering Menu',
            menu: { url: restaurant.selectedLocation.pdfCateringMenuLink },
          })
        }
      }
    }
    // Revert to restaurant menu
    if (arr.length < 1) {
      if (restaurant.pdfMenuLink) {
        arr.push({
          label: 'View Menu',
          menu: { url: restaurant.pdfMenuLink },
        })
      }

      if (restaurant.pdfCateringMenuLink) {
        arr.push({
          label: 'View Catering Menu',
          menu: { url: restaurant.pdfCateringMenuLink },
        })
      }
    }

    return arr
  }, [restaurant])

  return (
    <ul className="prg-menu-btns">
      {menus?.map((m) => {
        return (
          <li key={m.id}>
            <Link
              className="prg-primary-btn outline"
              to={`${m.menu.url}`}
              target="_blank"
            >
              {m.label}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default MenuSelectorComponent
